import Storage from 'react-native-storage';

const storage = new Storage({
  storageBackend: window.localStorage,
  defaultExpires: null, // never
  enableCache: true,
  sync: {
    credentials: () => ({}),
    'X-User-Id': () => ({ id: null }),
    'remember-me': () => ({ email: '' }),
  }
});

export default storage;
